import type { TreeMapFilterAssetTypeItem } from "./tree-map-filter-asset-type.type";

import { getAssetTreeNodeAssetsByType } from "@/entities/asset-tree";
import { sortTexts } from "@/utilities/string";

import { useTreeMap } from "../tree-map.context";
import { useTreeMapActiveAssets, useTreeMapAssets } from "../tree-map.hook";

export const useTreeMapFilterAssetType = () => {
  const { subFilters, toggleSubFilter, setFilterByType } = useTreeMap();

  const activeAssetsByType = useTreeMapActiveAssetsByAssetType();
  const assetTypes = useTreeMapAssetType();

  const filterItems = assetTypes.map(
    (assetType): TreeMapFilterAssetTypeItem => ({
      id: assetType.id,
      name: assetType.name,
      count: activeAssetsByType[assetType.id]?.length ?? 0,
      checked: subFilters.assetType?.includes(assetType.id),
    })
  );

  const onToggle = (assetTypeId: number, isChecked: boolean) => {
    toggleSubFilter({ type: "assetType", key: assetTypeId });

    // Activate parent filter if needed
    if (!isChecked) setFilterByType("asset", true);
  };

  return {
    filterItems,
    onToggle,
  };
};

const useTreeMapAssetType = () => {
  const assetNodes = useTreeMapAssets();

  return assetNodes
    .map(({ asset_type }) => asset_type)
    .filter(
      (asset_type, index, arr) =>
        arr.findIndex((t) => t.id === asset_type.id) === index
    )
    .sort((assetTypeA, assetTypeB) =>
      sortTexts(assetTypeA.name, assetTypeB.name)
    );
};

const useTreeMapActiveAssetsByAssetType = () => {
  const activeAssetNodes = useTreeMapActiveAssets();

  return getAssetTreeNodeAssetsByType(activeAssetNodes);
};
